import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Icon, Toaster,
} from 'anf-core-react';
import CheckoutPageContext from '../../../context/CheckoutPageContext';
import $window from '../../../tools/window';
import ExpressCheckoutWrapper from '../ExpressCheckout/ExpressCheckoutWrapper';

const PAYPAL_IMAGE_URL = 'https://img.abercrombie.com/is/image/anf/hol-M-20180411-lp-omni-paypal.png';
const EC_TOASTER_ID = 'express-checkout-toaster';

export default function ExpressCheckoutCTA() {
  const { checkoutPageState, updateCheckoutPageState } = useContext(CheckoutPageContext);
  const hasApplePay = checkoutPageState?.applePayButton?.hasApplePay && !!$window.ApplePaySession;
  const hasPayPal = checkoutPageState?.payPalExpressButton?.hasPayPal;
  const [open, setOpen] = useState(false);
  const isPAYPALPage = () => $window.location.href?.includes('/ProcessPayPalReturnAndOrderExpress');

  if (isPAYPALPage() || (!hasApplePay && !hasPayPal)) {
    return null;
  }

  return (
    <>
      <section
        aria-label="express-checkout-cta"
        className="express-checkout-cta"
      >
        <button
          type="button"
          className="express-checkout_hitarea"
          aria-label="Open express checkout"
          onClick={() => {
            setOpen(true);
          }}
        />
        <h3>
          <span>
            {checkoutPageState?.textFor?.expressCheckout?.value}
          </span>
        </h3>
        <Icon
          icon="right-thin"
          labelText="right-arrow"
          size="xxs"
        />
        <div className="express-checkout-logos">
          {hasApplePay && (
          <span
            data-testid="applepay-logo"
            className="applepay-logo"
          />
          )}
          <img
            data-testid="paypal-image"
            src={PAYPAL_IMAGE_URL}
            alt="paypal express button"
            className="paypal-image"
          />
        </div>
      </section>
      <ExpressCheckoutToaster
        isOpen={open}
        checkoutPageState={checkoutPageState}
        updateCheckoutPageState={updateCheckoutPageState}
        setOpen={setOpen}
      />
    </>
  );
}

function ExpressCheckoutToaster({
  isOpen, checkoutPageState, updateCheckoutPageState, setOpen,
}) {
  return (
    <Toaster id={EC_TOASTER_ID} direction="from-bottom" isOpen={isOpen} heading="Express Checkout" closeButtonLabel="Close" onClose={() => { setOpen(false); }}>
      <ExpressCheckoutWrapper
        pageContext={checkoutPageState}
        updatePageState={updateCheckoutPageState}
      />
    </Toaster>
  );
}

const TmntValueProp = PropTypes.shape({
  key: PropTypes.string,
  value: PropTypes.string,
});

const CheckoutPageStateProp = PropTypes.shape({
  applePayButton: PropTypes.shape({
    hasApplePay: PropTypes.bool,
  }),
  textFor: PropTypes.shape({
    expressCheckout: TmntValueProp,
  }),
});

ExpressCheckoutToaster.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  checkoutPageState: CheckoutPageStateProp,
  updateCheckoutPageState: PropTypes.func.isRequired,
  setOpen: PropTypes.func.isRequired,
};

ExpressCheckoutToaster.defaultProps = {
  checkoutPageState: {},
};
